// extracted by mini-css-extract-plugin
export var hero = "styles-module--hero--2DJPw";
export var contentWrapper = "styles-module--contentWrapper--EhrCq";
export var pageBody = "styles-module--pageBody--1wK-t";
export var policyContent = "styles-module--policyContent--1o6j2";